import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const toysApi = {
  list: (params = {}) => api.get("/toys", { params }).then((r) => r.data),
  get: (id) => api.get(`/toys/${id}`).then((r) => r.data),
  create: (payload) => api.post("/toys", payload).then((r) => r.data),
  update: (id, payload) => api.put(`/toys/${id}`, payload).then((r) => r.data),
  remove: (id) => api.delete(`/toys/${id}`).then((r) => r.data),
};

export const ordersApi = {
  list: () => api.get("/orders").then((r) => r.data),
  get: (id) => api.get(`/orders/${id}`).then((r) => r.data),
  create: (payload) => api.post("/orders", payload).then((r) => r.data),
};
